// libs
import React from 'react';
import { FormikValues } from 'formik';

import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';
import BaseForm from '@/components/Form';

// styles
import { formStyles } from './styles';
// types
import { FormProps } from './types';

function Form<TFormValues extends FormikValues = FormikValues>(props: FormProps<TFormValues>) {
  const { title, description, className, containerClassName, ...formProps } = props;

  return (
    <Box className={cn('h-full w-full', className)}>
      <Stack
        className={cn('mx-auto mt-48 flex-grow space-y-56 pb-40', formStyles, containerClassName)}
        direction="col">
        <Stack className="ms-8" direction="col" gapY={8}>
          <Typography variant="display-xl">{title}</Typography>
          <Typography color="text-text-secondary" variant="body-short-01">
            {description}
          </Typography>
        </Stack>
        <BaseForm<TFormValues> {...formProps} />
      </Stack>
    </Box>
  );
}

export default Form;
